var map = {
	"./applab/skins": 2427,
	"./bounce/skins": 2831,
	"./craft/agent/skins": 2835,
	"./craft/code-connection/skins": 2836,
	"./craft/designer/skins": 2834,
	"./craft/simple/skins": 2833,
	"./flappy/skins": 2837,
	"./jigsaw/skins": 2850,
	"./maze/skins": 2130,
	"./netsim/skins": 2861,
	"./p5lab/skins": 2306,
	"./studio/skins": 2863,
	"./studio/starwars/skins": 2454,
	"./turtle/skins": 2493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4229;